var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWorldwide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientTransform: "matrix(.655 -.756 .756 .655 -104.819 280.747)",
    gradientUnits: "userSpaceOnUse",
    x1: -0.019,
    x2: 500.43,
    y1: 255.203,
    y2: 255.203
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 170.483,
    x2: 392.097,
    y1: 170.498,
    y2: 392.113
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#60b7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0268b4"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c1e9af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4fc123"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.127,
    x2: 378.116,
    xlinkHref: "#lg1",
    y1: 324.327,
    y2: 410.316
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 267.381,
    x2: 297.741,
    xlinkHref: "#lg1",
    y1: 267.396,
    y2: 297.757
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 316.699,
    x2: 389.902,
    xlinkHref: "#lg1",
    y1: 76.442,
    y2: 149.646
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.245,
    x2: 134.331,
    xlinkHref: "#lg1",
    y1: 211.889,
    y2: 288.975
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.023,
    x2: 195.11,
    xlinkHref: "#lg1",
    y1: 151.11,
    y2: 228.197
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0268b4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0268b4"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.991,
    x2: 254.991,
    xlinkHref: "#lg2",
    y1: 317.255,
    y2: 448.097
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.502,
    x2: 79.897,
    y1: 422.764,
    y2: 458.159
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe99a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd4755"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 422.749,
    x2: 458.143,
    xlinkHref: "#lg3",
    y1: 44.518,
    y2: 79.912
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.25,
    x2: 200.418,
    xlinkHref: "#lg2",
    y1: 478.486,
    y2: 358.946
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(.707 .707 -.707 .707 346.789 -39.438)",
    gradientUnits: "userSpaceOnUse",
    x1: 118.19,
    x2: 157.434,
    xlinkHref: "#lg3",
    y1: 386.867,
    y2: 441.095
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientTransform: "matrix(.707 .707 -.707 .707 346.789 -39.438)",
    gradientUnits: "userSpaceOnUse",
    x1: 105.391,
    x2: 144.634,
    xlinkHref: "#lg3",
    y1: 396.129,
    y2: 450.357
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientTransform: "matrix(.707 .707 -.707 .707 346.789 -39.438)",
    gradientUnits: "userSpaceOnUse",
    x1: 93.1,
    x2: 132.344,
    xlinkHref: "#lg3",
    y1: 405.024,
    y2: 459.252
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m447.8 422.101c-3.433 3.96-7.049 7.881-10.746 11.654-1.362 1.388-2.734 2.756-4.117 4.106-3.526 3.441-9.174 3.372-12.615-.155-3.44-3.526-3.388-9.182.155-12.615 1.29-1.259 2.569-2.534 3.835-3.826 6.78-6.918 13.17-14.278 18.998-21.868 2.999-3.924 8.599-4.645 12.508-1.646s4.645 8.599 1.646 12.508c-3.083 4.016-6.334 8-9.664 11.842zm37.036-57.078c-2.544 2.934-6.814 3.959-10.508 2.237-4.466-2.082-6.399-7.389-4.316-11.855 4.818-10.334 8.92-21.127 12.193-32.079 1.411-4.718 6.38-7.404 11.103-5.992 4.72 1.411 7.403 6.383 5.992 11.103-3.522 11.779-7.935 23.389-13.117 34.506-.36.771-.816 1.467-1.347 2.08zm-93.412 105.243c-.573.661-1.254 1.248-2.035 1.734-10.441 6.488-21.457 12.264-32.74 17.168-4.519 1.964-9.774-.107-11.738-4.626-1.964-4.518.107-9.771 4.626-11.737 10.489-4.559 20.73-9.929 30.435-15.96 4.185-2.6 9.685-1.316 12.286 2.868 2.114 3.404 1.659 7.677-.834 10.553zm115.732-191.061c-1.782 2.055-4.478 3.274-7.401 3.059-4.914-.363-8.604-4.64-8.242-9.553.841-11.4.859-22.961.055-34.36-.346-4.914 3.355-9.181 8.27-9.527 4.915-.348 9.18 3.356 9.527 8.27.865 12.252.845 24.675-.058 36.927-.146 1.994-.937 3.783-2.151 5.184zm-198.346 223.456c-1.26 1.454-2.998 2.513-5.034 2.908-12.05 2.343-24.388 3.829-36.671 4.416-4.921.235-9.101-3.563-9.337-8.484-.235-4.921 3.561-9.103 8.485-9.337 11.427-.547 22.906-1.929 34.117-4.109 4.837-.94 9.519 2.218 10.46 7.054.545 2.802-.285 5.551-2.02 7.552zm188.897-311.652c-1.078 1.244-2.513 2.204-4.209 2.705-4.726 1.396-9.688-1.304-11.083-6.028-3.24-10.972-7.313-21.792-12.104-32.161-2.065-4.472-.117-9.772 4.357-11.84 4.472-2.066 9.773-.116 11.84 4.357 5.153 11.152 9.533 22.79 13.018 34.589.895 3.029.107 6.157-1.819 8.378zm-277.589 312.688c-1.974 2.277-5.055 3.499-8.242 2.957-12.121-2.061-24.185-5.024-35.856-8.806-4.687-1.518-7.256-6.549-5.736-11.236 1.517-4.69 6.549-7.255 11.236-5.736 10.855 3.517 22.074 6.273 33.347 8.19 4.857.826 8.125 5.433 7.299 10.29-.284 1.668-1.014 3.149-2.048 4.341zm-83.319-30.392c-2.764 3.189-7.494 4.053-11.261 1.835-10.569-6.223-20.791-13.29-30.382-21.007-3.838-3.088-4.447-8.704-1.359-12.543 3.112-3.828 8.704-4.447 12.543-1.359 8.919 7.176 18.424 13.748 28.249 19.533 4.246 2.5 5.661 7.968 3.161 12.214-.279.48-.599.922-.951 1.327zm-67.09-58.031c-.344.396-.727.768-1.149 1.109-3.836 3.092-9.452 2.489-12.544-1.347-7.723-9.58-14.799-19.796-21.033-30.364-2.503-4.243-1.095-9.713 3.152-12.216 4.243-2.504 9.713-1.092 12.216 3.151 5.796 9.825 12.375 19.323 19.556 28.231 2.75 3.414 2.576 8.236-.198 11.436zm295.041-377.927c-2.535 2.924-6.786 3.954-10.477 2.252-10.353-4.777-21.161-8.836-32.126-12.066-4.727-1.392-7.429-6.353-6.036-11.078 1.393-4.731 6.353-7.427 11.078-6.036 11.794 3.474 23.421 7.842 34.559 12.98 4.473 2.064 6.426 7.364 4.363 11.838-.361.782-.822 1.489-1.361 2.11zm-337.3 299.941c-1.027 1.185-2.38 2.114-3.979 2.634-4.686 1.522-9.718-1.042-11.241-5.728-3.794-11.675-6.768-23.745-8.84-35.872-.83-4.858 2.434-9.466 7.291-10.296 4.856-.83 9.466 2.434 10.295 7.29 1.928 11.281 4.694 22.507 8.222 33.365 1.003 3.085.233 6.322-1.748 8.607zm251.409-321.926c-1.774 2.047-4.456 3.264-7.366 3.061-11.4-.796-22.96-.768-34.361.081-4.913.367-9.193-3.32-9.559-8.233-.368-4.913 3.318-9.193 8.233-9.559 12.253-.914 24.677-.943 36.928-.088 4.916.343 8.622 4.606 8.279 9.52-.14 2.004-.932 3.808-2.154 5.218zm-263.194 233.985c-1.729 1.994-4.321 3.206-7.163 3.072-4.921-.231-8.723-4.408-8.492-9.329.575-12.275 2.051-24.609 4.383-36.662.935-4.836 5.617-7.999 10.453-7.064 4.838.937 8 5.616 7.064 10.454-2.17 11.213-3.542 22.689-4.079 34.109-.097 2.079-.9 3.959-2.166 5.42zm175.017-224.185c-1.071 1.235-2.493 2.191-4.175 2.695-10.962 3.285-21.766 7.402-32.111 12.233-4.464 2.085-9.773.156-11.858-4.308-2.084-4.465-.152-9.771 4.308-11.858 11.129-5.198 22.75-9.624 34.539-13.157 4.72-1.415 9.692 1.265 11.106 5.984.911 3.037.125 6.18-1.809 8.411zm-155.014 137.805c-2.484 2.865-6.627 3.926-10.289 2.337-4.52-1.959-6.596-7.213-4.635-11.733 4.889-11.277 10.652-22.29 17.129-32.732 2.592-4.183 8.095-5.477 12.283-2.88 4.187 2.597 5.476 8.096 2.88 12.283-6.02 9.707-11.378 19.943-15.923 30.426-.373.858-.863 1.628-1.445 2.299zm76.056-97.363c-.387.446-.823.859-1.309 1.233-8.778 6.751-17.189 14.215-24.998 22.181l-.657.673c-3.434 3.534-9.082 3.612-12.614.178s-3.592-9.093-.178-12.615l.682-.7c8.415-8.584 17.453-16.603 26.886-23.859 3.906-3.004 9.507-2.273 12.511 1.631 2.629 3.419 2.397 8.14-.323 11.278z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m459.577 255.007c0 112.99-91.596 204.586-204.586 204.586-112.275 0-203.426-90.441-204.575-202.444-.007-.713-.011-1.427-.011-2.142 0-53.149 32.664-90.385 65.892-126.76 26.559-29.075 49.002-61.637 88.391-71.595 16.093-4.069 32.946-6.23 50.304-6.23 22.672 0 44.482 3.688 64.864 10.496 12.802 4.276 21.568 14.237 33.102 20.835 8.178 4.678 19.474 5.451 26.894 11.176 48.49 37.41 79.725 96.096 79.725 162.078z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285.521 457.323c64.836-9.702 119.722-49.823 149.67-105.379l-26.15-26.15c-5.468-5.468-8.54-12.884-8.54-20.617 0-16.103-13.054-29.157-29.157-29.157h-38.245c-11.387 0-20.617 9.231-20.617 20.617 0 11.387-9.231 20.617-20.617 20.617h-2.052c-23.173 0-41.958 18.785-41.958 41.958 0 17.053 6.774 33.408 18.833 45.467 12.059 12.059 18.833 28.413 18.833 45.467z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.159,
    cy: 281.175,
    fill: "url(#SVGID_4_)",
    r: 26.168
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384.819 96.899c-19.036-15.65-40.947-27.929-64.823-35.925-8.758-2.933-17.822 3.562-17.822 12.798 0 3.58 1.422 7.013 3.954 9.545l7.852 7.852c6.911 6.911 10.794 16.285 10.794 26.058 0 9.774 3.883 19.147 10.794 26.058l12.678 12.678c5.915 5.915 13.937 9.238 22.302 9.238 17.419 0 31.54-14.121 31.54-31.54-.001-14.211-6.29-27.736-17.269-36.762z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 117.411,
    cy: 272.055,
    fill: "url(#SVGID_6_)",
    r: 13.084
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.545 121.589c7.743-7.743 12.093-18.245 12.093-29.195v-35.722c-88.64 22.436-154.233 102.721-154.233 198.335 0 .165 0 .33.001.495.047 19.544 23.835 29.196 37.654 15.376l3.463-3.463c4.136-4.136 6.46-9.746 6.46-15.596v-26.531c0-5.849 2.324-11.459 6.46-15.596l7.296-7.296c10.232-10.232 15.98-24.11 15.98-38.58 0-5.474 4.438-9.912 9.912-9.912 5.474 0 9.912 4.438 9.912 9.912v3.045c0 22.675-9.008 44.422-25.042 60.456-3.26 3.26-5.091 7.681-5.091 12.291 0 9.6 7.782 17.382 17.382 17.382 10.703 0 20.967-4.252 28.535-11.82l24.033-24.033c9.213-9.213 9.213-24.15 0-33.363-4.424-4.424-6.91-10.425-6.91-16.681v-20.308c.002-10.951 4.352-21.453 12.095-29.196z",
    fill: "url(#SVGID_7_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m51.083 271.659c8.476 105.2 96.526 187.934 203.909 187.934s195.432-82.734 203.908-187.934z",
    fill: "url(#SVGID_8_)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 65.868,
    cy: 444.13,
    fill: "url(#SVGID_9_)",
    r: 49.362
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444.114,
    cy: 65.883,
    fill: "url(#SVGID_10_)",
    r: 49.362
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.515 378.022c37.337 49.539 96.663 81.571 163.476 81.571 16.153 0 31.865-1.88 46.938-5.418l-122.458-122.459c-20.996-20.996-48.909-32.672-78.596-32.876-6.568-.045-11.929 5.243-11.974 11.811-.033 4.817 2.809 8.976 6.914 10.873l15.446 16.266c-3.396-.511-6.847-.8-10.337-.838-6.568-.072-11.95 5.194-12.022 11.762-.037 3.331 1.3 6.357 3.483 8.54l17.422 17.422c.067.067.142.126.211.192-2.875-.785-5.86-1.231-8.902-1.314-3.873-.105-7.352 1.662-9.601 4.468z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m191.45 418.209c-2.133-2.133-3.46-5.073-3.483-8.327-.161-23.396-9.362-45.394-25.91-61.941-16.547-16.547-38.545-25.749-61.941-25.91-6.568-.045-11.855-5.406-11.811-11.974.045-6.568 5.406-11.856 11.974-11.811 29.687.204 57.6 11.88 78.597 32.876 20.996 20.996 32.672 48.909 32.876 78.596.045 6.568-5.243 11.929-11.811 11.974-3.313.023-6.32-1.312-8.491-3.483z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.789 356.66c-2.183-2.183-3.52-5.209-3.483-8.54.072-6.568 5.454-11.834 12.022-11.762 19.488.213 37.814 7.923 51.602 21.711 13.787 13.787 21.498 32.113 21.711 51.602.072 6.568-5.194 11.95-11.762 12.022-6.568.071-11.95-5.194-12.022-11.762-.145-13.234-5.381-25.679-14.745-35.043s-21.809-14.601-35.043-14.745c-3.238-.037-6.159-1.362-8.28-3.483z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.739 418.208c-2.076-2.076-3.392-4.919-3.477-8.086-.096-3.532-1.526-6.855-4.029-9.357-2.502-2.502-5.825-3.933-9.357-4.029-6.566-.178-11.745-5.645-11.566-12.21.178-6.566 5.644-11.744 12.21-11.566 9.641.261 18.708 4.163 25.532 10.987s10.726 15.891 10.986 25.532c.178 6.566-5.001 12.032-11.566 12.21-3.399.091-6.504-1.252-8.733-3.481z",
    fill: "url(#SVGID_14_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorldwide);
export default __webpack_public_path__ + "static/media/icon-worldwide.a9298d3a1bcc635b97d79b53179fd97b.svg";
export { ForwardRef as ReactComponent };